<template>
    <div>
        <div v-if="items.length ===0" style="display: flex; justify-content: center; align-items: center; height: Calc(100vh - 180px);" class="favourites--empty">
            {{ $t('photos.no_favourites_added') }}
        </div>
        <div style="padding-top: 12px; padding-bottom: 20px; flex-grow: 1; flex-shrink: 1; overflow-y: auto; -webkit-overflow-scrolling: touch; scroll-behavior: smooth;">
            <div class="pm-gallery-media-grid" id="gallery_list_favourites">
                <template v-for="(item, idx) in items">
                    <pm-media-item class="pm-animation-fade-in-slide-down" :style="'--delay: '+Math.ceil((idx+1)/4) * 50+'ms'" @click="openViewer(idx)" :key="item.id" :item=item  style="position: relative;" />
                </template>
            </div>
        </div>
        <pm-premium-lock-screen v-if="!$IAP.hasAccessToComponent('photos')" track-label="lock_screen_photos_favourites" />
    </div>
</template>


<script>
import MediaList from "../../configs/gallery/media";
import PmMediaItem from "./media-item";
import PmPremiumLockScreen from "@/components/core/premium-lock-screen";

export default {
    name: "PmModGalleryFavourites",
    components: {
        PmMediaItem,
        PmPremiumLockScreen,
    },
    data: () => ({
        items: [],
    }),
    created() {
        this.items = this.getFavvedItems();
    },
    activated() {
        this.items = this.getFavvedItems();
    },
    computed: {
        is4in1() {
            return window.packageName === 'com.denticalc.4in1';
        },
    },
    methods: {
        openViewer(idx) {
            if (!this.$IAP.hasAccessToComponent('photos')) {
                this.showUpgrade();
                return;
            }
            const params = {
                start: idx,
                items: this.items,
                galleryId: 0,
                galleryTitle: "Favourites",
                categoryTitle: "Favourites"
            };
            this.$emit('openViewer', params);
        },
        reload() {
            this.items = this.getFavvedItems();
        },
        getFavvedItems() {
            const stored = localStorage.getItem('favvedGalleryMedia');
            if (stored === null) return [];
            const favved = JSON.parse(stored);
            const favvedItems = MediaList.filter((item) => {
                return favved.includes(item.src);
            });
            const withFilter = (v, i, a) => a.findIndex(t => t.src === v.src) === i;

            return favvedItems.filter(withFilter);
        },
    },
};

</script>

<style>
@media (min-width: 700px) {
    .gallery--premium-badge {
        font-size: 16px !important;
    }

    .gallery--premium-badge svg {
        width: 40px;
        height: 40px;
    }

    .favourites--empty {
        font-size: 16px !important;
    }
}
</style>
